import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DropdownItem } from '../../models/dropdown-item';
import { ChainBrandStore } from './chain-brand.store';
import { AuthenticationStore } from '../../../permission/services/authentication.store';

@Injectable()
export class ChainResolver implements Resolve<any> {

    constructor(private chainStore: ChainBrandStore, private authStore: AuthenticationStore) { }

    resolve(): Observable<DropdownItem[]> {
        let chains$: Observable<DropdownItem[]>;
        if (this.authStore.hasPermission('ViewAllChains')) {
            chains$ = this.chainStore.loadChains();
        }
        return chains$;
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/chainbrand/chain.resolver.ts